import { render, staticRenderFns } from "./IconLeftArrow.vue?vue&type=template&id=92938f44&"
import script from "./IconLeftArrow.vue?vue&type=script&lang=js&"
export * from "./IconLeftArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports